module.exports = __webpack_public_path__ + "img/banner_1.57add17e.png";